import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    QuestionDetails: {},
}

const QuestionSlice = createSlice({
    name: "QuestionSlice",
    initialState,

    reducers: {
        QuestionData(state, action) {
            return {
                QuestionDetails: action.payload.QuestionDetails,
            };
        }
    }
})
export const { QuestionData } = QuestionSlice.actions;
export default QuestionSlice.reducer;